export default __webpack_public_path__ + "static/media/icon-windcreek.501dbf19.svg";